import {
  AutoCompleteUncontrolled,
  ISelectType,
  useFetch,
} from "@4uhub/lib4uhub";
import { Box } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LanguagesService from "../../../services/languages.service";
import { ILanguageChangeNoAuthProps } from "./models";

const languagesService = new LanguagesService();

export const LanguageChangeNoAuth = memo(
  ({ top, left, colors }: ILanguageChangeNoAuthProps) => {
    const {
      i18n: { language, changeLanguage },
    } = useTranslation();

    const [options, setOptions] = useState<ISelectType[]>([]);

    const [value, setValue] = useState<ISelectType | null>(null);

    const { sendRequest } = useFetch(languagesService.list);

    const fetchFlag = useCallback((code: string) => {
      switch (code) {
        case "pt-BR":
          return "/brazil.png";
        case "en-US":
          return "/united-states.png";
        case "es":
          return "/spain.png";
        default:
          return null;
      }
    }, []);

    const fetchLanguages = useCallback(async () => {
      const { data, success } = await sendRequest(null);
      if (data && success) {
        setOptions(data);
        setValue(data.find((option) => option.code === language) || null);
      }
    }, [sendRequest, language]);

    const changeLanguageHandler = useCallback(
      (value: ISelectType | null) => {
        if (value && value.code) {
          changeLanguage(value.code);
        }
        setValue(value);
      },
      [changeLanguage]
    );

    useEffect(() => {
      fetchLanguages();
    }, [fetchLanguages]);

    return (
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 1,
          position: "absolute",
          top: top ?? 15,
          left: left ?? 15,
        }}
      >
        <AutoCompleteUncontrolled
          value={value}
          onValueSelected={changeLanguageHandler}
          options={options}
          label="Idioma"
          size="small"
          sx={{
            minWidth: 200,
            "& label.Mui-focused": {
              color: colors.secondary,
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: colors.secondary,
              },
            },
          }}
          clearable={false}
          renderOption={(props, option, state) => {
            const flag = option.code ? fetchFlag(option.code) : null;
            return (
              <li
                {...props}
                key={option.id}
                style={{
                  ...{ display: "flex", alignItems: "center", gap: 10 },
                  ...(state.selected ? { backgroundColor: colors.light } : {}),
                }}
              >
                {flag && (
                  <img
                    src={flag}
                    alt={option.name}
                    style={{ width: 25, height: "auto" }}
                  />
                )}
                {option.name}
              </li>
            );
          }}
        />
      </Box>
    );
  }
);
